import { GQL_ID, NestedFilter } from '@@partner:types:graphql'
import React, { useCallback } from 'react'

import FilterPanel from '@components/common/filter/FilterPanel'
import { createFilter } from '@components/common/filter/FilterConfig'
import { DELIVERY_ZONE_STATUS_LABELS } from '@@partner:config/deliveryZone'
import { makeFilter } from '@@partner:helpers/crud/filters'

export interface DeliveryZonesFiltersType {
  id?: GQL_ID
  name?: string
  status?: number[]
}

export interface DeliveryZonesFilterProps {
  onFilterChanged: (filters: NestedFilter) => void
  baseFilter?: NestedFilter
}

const defaultFilter: DeliveryZonesFiltersType = {
  id: undefined,
  name: undefined,
  status: undefined
}

export const prepareDeliveryZonesFilter = (
  filters: DeliveryZonesFiltersType,
  baseFilter?: NestedFilter
): NestedFilter => {
  const conditions: NestedFilter[] = []
  
  // Добавляем базовый фильтр (brand_id)
  if (baseFilter) {
    conditions.push(baseFilter)
  }

  const idFilter = makeFilter('id', 'eq', filters.id)
  const nameFilter = makeFilter('name', 'includes', filters.name)
  const statusFilter = makeFilter('status', 'contains', filters.status)

  conditions.push(idFilter as NestedFilter, nameFilter as NestedFilter, statusFilter as NestedFilter)

  return { and: conditions }
}

const filterConfig = [
  createFilter.text('id', 'ID'),
  createFilter.text('name', 'Название'),
  createFilter.multiselect('status', DELIVERY_ZONE_STATUS_LABELS, 'Статус', {
    searchable: false
  })
]

export default function DeliveryZonesFilter ({
  onFilterChanged,
  baseFilter
}: DeliveryZonesFilterProps) {
  const handleSubmit = useCallback((state: DeliveryZonesFiltersType) => {
    onFilterChanged(prepareDeliveryZonesFilter(state, baseFilter))
  }, [ onFilterChanged, baseFilter ])

  return (
    <FilterPanel
      filters={filterConfig}
      defaultState={defaultFilter}
      onSearch={handleSubmit}
    />
  )
}
